export { generateImage } from './generate-image';
export type { GenerateImageResult } from './generate-image-result';

// deprecated exports

import { generateImage } from './generate-image';
/**
 * @deprecated Use `generateImage` instead.
 */
const experimental_generateImage = generateImage;
export { experimental_generateImage };

import type { GenerateImageResult } from './generate-image-result';
/**
 * @deprecated Use `GenerateImageResult` instead.
 */
type Experimental_GenerateImageResult = GenerateImageResult;
export type { Experimental_GenerateImageResult };
